import { useHistory, useLocation } from 'react-router-dom';
import i18next from 'i18next';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';

import { hasAppSession } from '@commons/auth/session';
import mosAuth, { isMosLoginConfigured } from '@services/mosAuth';

/**
 * Public MOS product-switcher entry. Starts Authorization Code + PKCE when unauthenticated.
 */
const MosEntry = () => {
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState(null);

  useEffect(() => {
    const start = async () => {
      if (!isMosLoginConfigured()) {
        setError(i18next.t('GENERAL.CONNECTION_MOS_FAILURE'));

        return;
      }

      if (hasAppSession()) {
        history.replace('/home');

        return;
      }

      const queryParams = qs.parse(location.search || '');
      const returnUrl = queryParams.returnUrl || queryParams.return_url || '/home';

      try {
        await mosAuth.startMosLogin({ returnUrl });
      } catch {
        setError(i18next.t('GENERAL.CONNECTION_MOS_FAILURE'));
      }
    };

    start();
  }, [history, location.search]);

  if (error) {
    return <div>{error}</div>;
  }

  return null;
};

export default MosEntry;
